var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"text-center text-danger my-2"},[_c('b-spinner',{staticClass:"align-middle"}),_vm._v(" "),_c('strong',{domProps:{"textContent":_vm._s(_vm.$t('loading'))}})],1):_c('div',[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }